import { Controller } from "@hotwired/stimulus";
import GLightbox from "glightbox";

export default class extends Controller {
  static values = {
    id: String,
  };

  connect() {
    // Select images for this specific gallery
    const images = document.querySelectorAll(`[data-gallery="${this.idValue}"]`);

    if (images.length > 0) {
      this.initializeLightbox();
    }
  }

  disconnect() {
    // Ensure proper cleanup when the element is disconnected
    if (this.gallery) {
      this.gallery.destroy();
    }
  }

  initializeLightbox() {
    this.gallery = GLightbox({
      selector: `[data-gallery="${this.idValue}"]`, // Target only this gallery
      touchNavigation: true,
      loop: true,
    });
  }

  openGallery(event) {
    if (!this.gallery) return;

    const clickedImage = event.target.closest("img");

    if (clickedImage) {
      const images = this.gallery.getElements();
      const clickedSrc = clickedImage.src;
      const index = images.findIndex((item) => item.href === clickedSrc);
      this.gallery.openAt(Math.max(0, index));
    } else {
      this.gallery.openAt(0);
    }
  }

  reload() {
    if (this.gallery) {
      this.gallery.reload();
    }
  }
}
